module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "changePwd"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPwd),
      expression: "newPwd"
    }],
    attrs: {
      "type": "password",
      "placeholder": "新密码"
    },
    domProps: {
      "value": (_vm.newPwd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPwd = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.re_newPwd),
      expression: "re_newPwd"
    }],
    attrs: {
      "type": "password",
      "placeholder": "确认密码"
    },
    domProps: {
      "value": (_vm.re_newPwd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.re_newPwd = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "next"
  }, [_c('input', {
    attrs: {
      "type": "button",
      "value": "确认修改"
    },
    on: {
      "click": _vm.next
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title_wrap"
  }, [_c('span', {
    staticClass: "title_name"
  }, [_vm._v("修改密码")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8b2ccb00"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/UserChangePwd.vue
// module id = 625
// module chunks = 1